import { render, staticRenderFns } from "./EventInformationCard.vue?vue&type=template&id=315e3dbe&scoped=true&"
import script from "./EventInformationCard.vue?vue&type=script&lang=js&"
export * from "./EventInformationCard.vue?vue&type=script&lang=js&"
import style0 from "./EventInformationCard.vue?vue&type=style&index=0&id=315e3dbe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315e3dbe",
  null
  
)

export default component.exports